module.exports = __webpack_public_path__ + "img/PULSIVE VENTIL ROOF 2S.71b48dda.jpg";